import {
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
} from '../../../constants/api'
import { getEmailMessages } from '../Email.api'

export async function emailMessageProfilePrintDataLoader({ params }) {
  const { mailUuid } = params

  try {
    const response = await getEmailMessages({
      params: {
        uuid: [mailUuid],
      },
    })

    const item = response?.data?.items?.[0]

    if (!item) {
      throw new Response('Message not found', { status: HTTP_STATUS_NOT_FOUND })
    }

    return item
  } catch (error) {
    if (error instanceof Response) {
      throw error
    }

    const status = error?.response?.status ?? HTTP_STATUS_INTERNAL_SERVER_ERROR
    const message =
      error?.response?.data?.message ??
      error?.message ??
      'Failed to load message raw data'

    throw new Response(message, { status })
  }
}
